import { configureStore, combineReducers } from '@reduxjs/toolkit'
import authSlice from './slices/authSlice.js'
import bomberosSlice from './slices/bomberosSlice.js'
import citacionesSlice from './slices/citacionesSlice.js'
import circularesSlice from './slices/circularesSlice.js'
import cuadroListasSlice from './slices/cuadroListasSlice.js'
import emergenciasSlice from './slices/emergenciasSlice.js'
import clavesSlice from './slices/clavesSlice.js'
import cargosSlice from './slices/cargosSlice.js'
import categoriasSlice from './slices/categoriasSlice.js'
import materialSlice from './slices/materialSlice.js'
import carrosSlice from './slices/carrosSlice.js'
import guardiasSlice from './slices/guardiasSlice.js'
import licenciasSlice from './slices/licenciasSlice.js'
import tiposBomberoSlice from './slices/tiposBomberoSlice.js'
import especialidadesSlice from './slices/especialidadesSlice.js'
import themeSlice from './slices/themeSlice.js'
import cuotasSlice from './slices/cuotasSlice.js'
import preferenciasSlice from './slices/preferenciasSlice.js'
import ramasSlice from './slices/ramasSlice.js'
import notificacionesSlice from './slices/notificacionesSlice.js'
import estadisticasSlice from './slices/estadisticasSlice.js'
import operadoresSlice from './slices/operadoresSlice.js'
import companiaServicioSlice from './slices/companiaServicioSlice.js'

const combinedReducer = combineReducers({
  auth: authSlice,
  bomberos: bomberosSlice,
  citaciones: citacionesSlice,
  circulares: circularesSlice,
  cuadroListas: cuadroListasSlice,
  emergencias: emergenciasSlice,
  claves: clavesSlice,
  cargos: cargosSlice,
  categorias: categoriasSlice,
  material: materialSlice,
  carros: carrosSlice,
  guardias: guardiasSlice,
  licencias: licenciasSlice,
  tiposBombero: tiposBomberoSlice,
  especialidades: especialidadesSlice,
  theme: themeSlice,
  cuotas: cuotasSlice,
  preferencias: preferenciasSlice,
  ramas: ramasSlice,
  notificaciones: notificacionesSlice,
  estadisticas: estadisticasSlice,
  operadores: operadoresSlice,
  companiaServicio: companiaServicioSlice,
})

// Reset global del store al cerrar sesión: evita que datos del usuario/tenant anterior
// (notificaciones, cuotas, bomberos, etc.) queden en memoria al loguear otra cuenta en
// la misma pestaña (SPA sin recarga dura). Se preserva 'theme' (preferencia de UI, no de sesión).
const rootReducer = (state, action) => {
  if (state && (action.type === 'auth/logoutUser/fulfilled' || action.type === 'auth/clearAuth')) {
    state = { theme: state.theme }
  }
  return combinedReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar acciones específicas que pueden contener valores no serializables
        ignoredActions: [
          'persist/PERSIST', 
          'persist/REHYDRATE',
          'bomberos/fetchStats/fulfilled',
          'bomberos/fetchBomberos/fulfilled',
        ],
        // Ignorar paths específicos en el estado
        ignoredActionPaths: ['payload.headers', 'payload.config', 'payload.request'],
        ignoredPaths: ['payload.headers', 'payload.config', 'payload.request'],
      },
    }),
})

export default store